import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { assert_false, assert_type_enum } from '@shared/asserts/utils_asserts';
import { ENUM__t2i_adapter_type, ENUM_UTILS__t2i_adapter_type } from '@shared/dto/+model/sd/_enums/ENUM__t2i_adapter_type';
import { FIELD_PRIMITIVE__base_string } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/FIELD_PRIMITIVE__base_string';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { FIELD__ml_asset_t2i_adapter } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance/FIELD__ml_asset_t2i_adapter';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_UI_FIELD_PRIMITIVE__string_dropdown } from '../primitive_string/G_UI_FIELD_PRIMITIVE__string_dropdown';

interface PROPS {
  field: FIELD__ml_asset_t2i_adapter;
}

export function G_UI_FIELD__ml_asset_t2i_adapter({ field }: PROPS) {
  const { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  /*
   * EVENTS
   */

  function on_value_changed(graph_new: DTO_GRAPH__instance, field_new: FIELD_PRIMITIVE__base_string) {
    assert_false(field.image.is_stub());

    let t2i_adapter_type = field_new.get_value();
    assert_type_enum(t2i_adapter_type, ENUM__t2i_adapter_type);

    let image_category_new = ENUM_UTILS__t2i_adapter_type.get_image_category_for(t2i_adapter_type);
    if (image_category_new == ENUM__image_asset_category.ANY) return; //no need to clear image
    if (image_category_new == field.image.category) return; //no need to clear image

    field.image.image__clear();
    graph_new.field__replace(field.image);
  }

  /*
   *
   */

  if (!field.image.image__is_initialized) return <PLACEHOLDER_bar_line />;

  return (
    <>
      <div className="flex flex-col w-full min-w-0" {...{ onMouseOver, onMouseLeave }}>
        <G_UI_FIELD__header {...{ field }} />
        <G_UI_FIELD_PRIMITIVE__string_dropdown field={field.type} {...{ on_value_changed }} />
      </div>
    </>
  );
}
